import { Component, Input, OnInit } from '@angular/core';
import { appendLeadingZeros } from '@app/core/helpers';
import { ChatStatisticsResponse } from '@projects/shared/src/app/features/insight/interfaces/Dashboard/ChatStatisticsResponse';

import { momentCustom as moment, momentCustomInstance as momentInst } from '@projects/shared/src/app/utils/helper';

@Component({
  selector: 'app-chat-statistics',
  templateUrl: './chat-statistics-updated.component.html',
  styleUrls: ['./chat-statistics.component.scss'],
})
export class ChatStatisticsComponent implements OnInit {
  @Input() conversationRateConfig: any;
  @Input() visitorToChatConfig: any;
  @Input() data?: ChatStatisticsResponse;
  @Input() title: string | undefined;
  constructor() {}

  ngOnInit(): void {}

  formatTime(time: number) {
    const duration = moment().duration(time, 'seconds');
    const hh = duration.years() * (365 * 24) + duration.months() * (30 * 24) + duration.days() * 24 + duration.hours();
    const mm = duration.minutes();
    const ss = duration.seconds();
    return `${appendLeadingZeros(hh)}:${appendLeadingZeros(mm)}:${appendLeadingZeros(ss)}`;
  }
}
